import { connect } from 'react-redux';
import { denormalize } from 'normalizr';
import { schema } from '../../../../../state/schema';

import BulkSmsMessageModal from '../components/BulkSmsMessageModal';
import storage from '../../../../../lib/Storage';
import { findStorageType } from '../../../../../lib/Auth';
import {
  loadUserProfilesPartnership,
  clearUserProfilesPartnershipPages,
} from '../../../../../state/modules/userProfilesPartnerships/actions';
import { createBulkSmsMessages } from '../../../../../state/modules/smsMessages/actions';

const mapStateToProps = (state, ownProps) => {
  const partnershipId = storage.get(findStorageType(), 'partnershipId');
  const limit = 20;
  const order = 'updated_at.asc';
  const page = 1;

  const result = state.userProfilesPartnerships.getIn([
    'pages',
    partnershipId,
    order,
    limit,
    page,
  ]);

  const list = result
    ? result
        .map((x) => {
          return {
            key: x,
            ...denormalize(
              state.entities.getIn(['userProfilesPartnerships', x]),
              schema.userProfilePartnership,
              state.entities.toJS()
            ),
          };
        })
        .toArray()
    : [];

  return {
    page: page,
    limit: limit,
    order: order,
    partnershipId: partnershipId,
    list: list,
    total: state.userProfilesPartnerships.get('total'),
    isLoading: state.userProfilesPartnerships.get('isLoading'),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    load: (partnershipId, page, limit, order, filter, cb) => {
      dispatch(
        loadUserProfilesPartnership(
          partnershipId,
          page,
          limit,
          order,
          filter,
          cb
        )
      );
    },
    clearPages: (partnershipId) => {
      dispatch(clearUserProfilesPartnershipPages(partnershipId));
    },
    createBulkSmsMessages: (partnershipId, data, cb) => {
      dispatch(createBulkSmsMessages(partnershipId, data, cb));
    },
  };
};

const BulkSmsMessageModalContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(BulkSmsMessageModal);

export default BulkSmsMessageModalContainer;
